import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchUsersList } from "../../Redux/Slice/Users/UsersListSlice";
import { Pagination } from "../../Common/Pagination";
import { useLocation, useNavigate } from "react-router-dom";
import { Table } from "../../Common/Table";
import { debounce } from "../../Common/debounce";
import { DeleteUser } from "../../Redux/Slice/Users/DeleteUserSlice";
import { ErrorModel } from "../../Model/ErrorModel";
import { SuccessModel } from "../../Model/SuccessModel";
import {
  setPage,
  setTotalItems,
  setTotalPages,
} from "../../Redux/Slice/Common/PaginationSlice";
import { ConfirmModel } from "../../Model/ConfirmModel";
import { phoneNumberFormat } from "../../Common/Validations";
import { Loader } from "../../Common/Loader";
import useDebounce from "../../Common/useDebounce";
import { dateFormat } from "../../Common/DateAndTimeFormat";
import { updateUser } from "../../Redux/Slice/Users/UpdateUserSlice";
import { maskPhoneNumber } from "../../Common/utils";
import { DeleteCustomer } from "../../Redux/Slice/Customers/DeleteCustomerSlice";
import { LIMIT_PER_PAGE } from "../../Common/Constants";

export const UserList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const userData = JSON.parse(localStorage.getItem("userData"));
  const isFromCustomerUser =
    location.pathname.includes("customerUser") || userData?.customer?.id;
  const customerId = isFromCustomerUser ? location.pathname.split("/")[2] : "";
  const [userList, setUsersList] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [localItemsPerPage, setLocalItemsPerPage] = useState(LIMIT_PER_PAGE);
  const searchQuery = useDebounce(searchText, 500);
  const [errorModel, setErrorModel] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successModel, setSuccessModel] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [confirmModel, setCOnfirmModel] = useState(false);
  const [selectedRow, setselectedRow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const users = useSelector((state) => state.users.uersList);
  const getUsersLits = async (page = 1, limit) => {
    setIsLoading(true);
    const result = await dispatch(
      fetchUsersList({ searchText, page, customerId: customerId, limit })
    );
    setIsLoading(false);
    dispatch(setPage(result?.payload?.pagination?.currentPage));
    dispatch(setTotalItems(result?.payload?.pagination?.totalItems));
    dispatch(setTotalPages(result?.payload?.pagination?.totalPages));
  };

  const handleUpdateUser = async (payload) => {
    setIsLoading(true);
    let formData2 = new FormData();
    const data = {
      parentCustomerId: customerId,
      ...payload,
    };
    formData2.append("body", JSON.stringify({ ...data }));
    const result = await dispatch(
      updateUser({ id: payload?.id, formData: formData2 })
    );
    if (
      updateUser.fulfilled.match(result) &&
      result?.payload?.success === true
    ) {
      setIsLoading(false);
      setSuccessMessage("User Updated Successfully!");
      setSuccessModel(true);
      setTimeout(() => {
        setSuccessModel(false);
        getUsersLits(1, localItemsPerPage);
      }, 1500);
    } else {
      setIsLoading(false);
      setErrorMessage(result?.payload?.error?.message);
      setErrorModel(true);
      setTimeout(() => {
        setErrorModel(false);
      }, 1500);
    }
  };

  const setPageList = (users) => {
    if (!!users) {
      return users.map((item, index) => {
        return {
          ...item,
          count: index + 1,
          avatar: item?.avatar,
          firstName: item?.firstName,
          lastName: item?.lastName,
          email: item?.email,
          signedUp:
            item?.signedUpDate && dateFormat(item?.signedUpDate) != "NaN/NaN/NaN"
              ? dateFormat(item?.signedUpDate)
            : item?.createdAt && dateFormat(item?.createdAt) != "NaN/NaN/NaN"
              ? dateFormat(item?.createdAt)
              : "",
          phoneNumber: item?.phoneNumber
            ? maskPhoneNumber(item?.phoneNumber, item?.countryCallingCode)
            : "",
          role:
            typeof item?.role?.name == "string"
              ? item?.role?.name.charAt(0).toString().toUpperCase() +
                item?.role?.name.substring(1)
              : item?.role?.name,
          id: item?.id,
          lastLoginDate:
            item?.lastLoginDate &&
            dateFormat(item?.lastLoginDate) != "NaN/NaN/NaN"
              ? dateFormat(item?.lastLoginDate)
              : "",
        };
      });
    }
  };
  // useEffect(() => {
  //   getUsersLits(1);
  // }, []);
  useEffect(() => {
    if (users) {
      setUsersList(users.data);
    }
  }, [users]);

  const debouncedGetUserList = useCallback(debounce(getUsersLits, 500), [
    searchQuery,
  ]);

  useEffect(() => {
    debouncedGetUserList(1, localItemsPerPage);
  }, [searchQuery, debouncedGetUserList, customerId]);

  const columns = isFromCustomerUser
    ? [
        {
          label: "First Name",
          key: "firstName",
          avatarKey: "avatar",
          className: "profile",
        },
        {
          label: "Last Name",
          key: "lastName",
          className: "cellText",
        },
        {
          label: "Email",
          key: "email",
          className: "cellText",
        },
        {
          label: "Role",
          key: "role",
          className: "cellText",
        },
        {
          label: "Phone Number",
          key: "phoneNumber",
          className: "cellText",
        },
        {
          label: "Signed up",
          key: "signedUp",
          className: "cellText",
        },
        {
          label: "Last Login Date",
          key: "lastLoginDate",
          className: "cellText",
        },
        {
          label: "Status",
          key: "isActive",
          className: "switchBtn",
          disabledKey: "isUserEditable",
          onSwitchValueChanged: (val, rowData) => {
            handleUpdateUser({
              id: rowData?.id,
              isActive: val,
            });
          },
        },
        {
          label: "MFA",
          key: "isMfaEnabled",
          className: "switchBtn",
          onSwitchValueChanged: (val, rowData) => {
            handleUpdateUser({
              id: rowData?.id,
              isMfaEnabled: val,
            });
          },
        },
      ]
    : [
        {
          label: "First Name",
          key: "firstName",
          avatarKey: "avatar",
          className: "profile",
        },
        {
          label: "Last Name",
          key: "lastName",
          className: "cellText",
        },
        {
          label: "Email",
          key: "email",
          className: "cellText",
        },
        {
          label: "Role",
          key: "role",
          className: "cellText",
        },
        {
          label: "Phone Number",
          key: "phoneNumber",
          className: "cellText",
        },
        {
          label: "Signed up",
          key: "signedUp",
          className: "cellText",
        },
      ];

  const onEdit = (row) => {
    if (row?.role == "Company") {
      navigate("/edit-customer/" + row?.customer?.id,{
        state: {
          isEditAdmin: true,
        },
      });
      return;
    }
    navigate("/edit-user/" + row.id, {
      state: {
        isFromCustomerUserListing: isFromCustomerUser,
        parentCustomerId: customerId,
      },
    });
  };

  const onDeleteClick = (row) => {
    setCOnfirmModel(true);
    setselectedRow(row);
  };

  const onDeleteCustomerAdminConfirm = async () => {
    setCOnfirmModel(false);
    const result = await dispatch(DeleteCustomer(selectedRow?.customer?.id));
    if (
      DeleteCustomer.fulfilled.match(result) &&
      result?.payload?.success === true
    ) {
      setSuccessMessage("Customer Deleted Successfully!");
      setSuccessModel(true);
      setTimeout(() => {
        setSuccessModel(false);
        navigate(-1);
      }, 1500);
    } else {
      setErrorMessage(result?.payload?.error?.message);
      setErrorModel(true);
      setTimeout(() => {
        setErrorModel(false);
      }, 1500);
    }
  };

  const onDelete = async () => {
    setCOnfirmModel(false);
    const result = await dispatch(DeleteUser(selectedRow.id));
    if (
      DeleteUser.fulfilled.match(result) &&
      result?.payload?.success === true
    ) {
      setSuccessMessage("User Deleted Successfully!");
      setSuccessModel(true);
      setTimeout(() => {
        setSuccessModel(false);
        getUsersLits(1, localItemsPerPage);
      }, 1500);
    } else {
      //TODO: error popup here

      setErrorMessage(result?.payload?.error?.message);
      setErrorModel(true);
      setTimeout(() => {
        setErrorModel(false);
      }, 1500);
    }
  };
  return (
    <div>
      {errorModel ? <ErrorModel message={errorMessage} /> : ""}
      {successModel ? <SuccessModel message={successMessage} /> : ""}
      {isLoading ? <Loader /> : ""}
      {confirmModel ? (
        <ConfirmModel
          onAccept={
            selectedRow?.role == "Company"
              ? onDeleteCustomerAdminConfirm
              : onDelete
          }
          onReject={() => {
            setCOnfirmModel(false);
          }}
          title="Delete User!"
          message="Are you sure you want to Delete the user?"
        />
      ) : (
        ""
      )}
      <div className="page__body">
        <div className="tableWrap">
          <div className="tableWrap__head">
            <div className="formRow m_0 formRow--flexEnd">
              <div className="formCol formCol--flexInput">
                <div className="formCol flexField">
                  <input
                    className="form__input form__input--search"
                    type="text"
                    value={searchText}
                    onChange={(e) => {
                      setSearchText(e.target.value.trimStart());
                    }}
                    placeholder="Search Name, Email or Role"
                  />
                </div>
                {/* <button className="btn btn__white">
                  <svg
                    width="20"
                    height="14"
                    viewBox="0 0 20 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.52637 7H15.5264M1.77637 1.5H18.2764M7.27637 12.5H12.7764"
                      stroke="#475569"
                      stroke-width="1.837"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  Filter
                </button> */}
              </div>
            </div>
            <div className="btn__group">
              <button
                className="btn btn__primary"
                onClick={() =>
                  navigate("/add-user", {
                    state: {
                      isFromCustomerUserListing: isFromCustomerUser,
                      parentCustomerId: customerId,
                    },
                  })
                }
              >
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.00008 1.1665V12.8332M1.16675 6.99984H12.8334"
                    stroke="white"
                    stroke-width="1.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                Add User
              </button>
            </div>
          </div>
          <Table
            columns={columns}
            data={setPageList(userList)}
            onEdit={onEdit}
            onDelete={onDeleteClick}
            hasAction="true"
            isShowActionKey={"isUserEditable"}
            noDataMsg={
              searchQuery && searchQuery?.length ? `No user found!` : `No user!`
            }
          />
        </div>
      </div>
      <Pagination 
        apiMethod={getUsersLits} 
        itemsPerPage={localItemsPerPage}
        setItemsPerPage={setLocalItemsPerPage}
      />
    </div>
  );
};
